module.exports = __webpack_public_path__ + "./assets/img_kaostation_grey__12098552e704a5ba8cf019200c58e4ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/img_kaostation_grey.jpg
// module id = 599
// module chunks = 12